import React, { Fragment, useState } from 'react'
import styled, { withTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { desktop, mobile } from '../../styles/media'
import { formatCurrency } from '../../helper/string'
import Icon from '../../components/general/Icon'
import SimpleProgressBar from '../../components/general/SimpleProgressBar'
import { PrintList } from '../../components/card/PrintList'
import { calculateDeckPriceData } from '../../helper/prices'
import CardName from '../../components/card/name/CardName'
import { getArtworkNumber, getCardImage, getCardName, groupDeckCards } from '../../helper/card'
import CardPriceAmount, { StyledCardPriceAmount } from '../../components/price/CardPriceAmount'
import SkipButton, { StyledSkipButton } from '../../components/button/SkipButton'
import translate from '../../helper/translate'
import Link from '../../components/router/Link'
import priceSources, { priceSourceCurrencies } from '../../data/priceSources'
import ThickHeading from '../../components/text/ThickHeading'
import Message from '../../components/form/Message'
import { setReference, shouldReload, showToast } from '../../state/actions/app'
import { getMissingCards } from '../../helper/deck'
import DeckBuyLinks from './components/DeckBuyLinks'
import { post } from '../../helper/api'
import Select from '../../components/form/Select'
import ToolbarButton from '../../components/button/ToolbarButton'
import { StyledInputContainer } from '../../components/form/Input'
import history from '../../helper/history'
import { queueCollectionStatsUpdate } from '../../state/actions/collection'
import { getCollectionsOptions } from '../../helper/collection'
import { RegionLink, Regions } from '../../components/card/Regions'

const DeckCollectionHelper = ({ cardNameLanguage, collections, deckCards, deckSlug, flyout, priceSource, queueCollectionStatsUpdate, setReference, shouldReload, showToast, subscribed, t, theme, type }) => {
	const [action, setAction] = useState('complete')
	const [expanded, setExpanded] = useState(flyout)
	const [scope, setScope] = useState('missing')

	const currency = priceSourceCurrencies[priceSource]

	const { priceTotal } = calculateDeckPriceData(deckCards)

	const missingCards = getMissingCards(deckCards)

	const total = deckCards.filter(item => item.place !== 'note').length
	const haves = deckCards.filter(item => item.place !== 'note' && item.ownsCard).length
	const havesPrice = deckCards.filter(item => item.place !== 'note' && item.ownsCard).reduce((a, b) => a + b.price, 0)
	const missing = deckCards.filter(item => item.place !== 'note' && !item.ownsCard).length
	const missingPrice = deckCards.filter(item => item.place !== 'note' && !item.ownsCard).reduce((a, b) => a + b.price, 0)

	const [wantsList, setWantsList] = useState(null)
	const [addToWantsListLoading, setAddToWantsListLoading] = useState(false)

	const addToWantsList = () => {
		if (!subscribed) {
			history.push('/product/collection-manager')
			return
		}

		setAddToWantsListLoading(true)

		post(`decks/${deckSlug}/addToWants`, {
			cardIds: scope === 'missing' ? missingCards.map(item => item.card.id) : deckCards.map(item => item.card.id),
			quantities: scope === 'missing' ? missingCards.map(item => item.missing) : deckCards.map(item => 1),
			collectionSlug: wantsList
		}, (collectionSlug) => {
			setAddToWantsListLoading(false)
			shouldReload('collections')
			queueCollectionStatsUpdate(collectionSlug)
			showToast('success', t('general.addToWantsListSuccess'))
			history.push(`/collection/${collectionSlug}`)
		}, () => {
			setAddToWantsListLoading(false)
			showToast('error', t('general.addToWantsListError'), null)
		})
	}

	return (
		<StyledDeckCollectionHelper>
			{type === 'collection' && (
				<ThickHeading>{t('general.collectionProgress')}</ThickHeading>
			)}
			{type === 'priceBreakdown' && (
				<ThickHeading>{t('general.priceBreakdown')}</ThickHeading>
			)}

			{/*{!subscribed && type === 'collection' && (
				<Message primary light icon="information-circle">
					<strong>{t('general.deckCollectionStatusNotSubscribed')}</strong><br />
					{t('general.deckCollectionStatusNotSubscribed2')}&nbsp;<Link to="/pricing" onBeforeNavigate={() => setReference(references.DECK_COLLECTION_STATUS)}>{t('general.unlockNow')}</Link>
				</Message>
			)}*/}

			{type === 'priceBreakdown' && deckCards.length === 0 && (
				<Message info icon="information-circle">
					{t('general.priceBreakdownEmpty')}
				</Message>
			)}

			{/*<Action>
				<ActionButton2
					active={action === 'complete'}
					onClick={() => setAction('complete')}
				>
					<Icon name="check-circle" />
					Vervollständigen
				</ActionButton2>
				<ActionButton2
					active={action === 'upgrade'}
					onClick={() => setAction('upgrade')}
				>
					<Icon name="sparkles" />
					Karten upgraden
				</ActionButton2>
			</Action>*/}

			{type === 'collection' && (
				<>
					<ProgressItem>
						<ProgressDetails>
							<ProgressHaves>
								{haves}
							</ProgressHaves>
							<ProgressTotal>
								/ {total} {t('general.card', { count: total })}
							</ProgressTotal>
						</ProgressDetails>
						<SimpleProgressBar
							background="backgroundVeryLight"
							percent={haves / total * 100}
						/>
					</ProgressItem>

					<ProgressItem>
						<ProgressDetails>
							<ProgressHaves>
								{formatCurrency(currency, havesPrice)}
							</ProgressHaves>
							<ProgressTotal>
								/ {formatCurrency(currency, priceTotal)}
							</ProgressTotal>
						</ProgressDetails>
						<SimpleProgressBar
							color="gold2"
							background="backgroundVeryLight"
							percent={havesPrice / priceTotal * 100}
						/>
					</ProgressItem>
				</>
			)}

			{type === 'collection' && (
				<ProgressItem>
					<MissingTitle>{t('general.youreMissing')}</MissingTitle>

					<MissingItems>
						<MissingItem>
							<MissingItemValue>
								{missing}
							</MissingItemValue>
							<MissingItemLabel>
								{t('general.card', { count: missing })}
							</MissingItemLabel>
						</MissingItem>
						<MissingItem>
							<MissingItemValue>
								{formatCurrency(currency, missingPrice)}
							</MissingItemValue>
							<MissingItemLabel>
								{t('general.price')}
							</MissingItemLabel>
						</MissingItem>
					</MissingItems>
				</ProgressItem>
			)}

			{type === 'collection' && missing === 0 && (
				<Message info icon="information-circle">
					{t('general.deckNoMissingCards')}
				</Message>
			)}

			{type === 'collection' && (
				<>
					<ThickHeading><Icon name="document-add" />{t('general.add')}</ThickHeading>

					<AddToWantsList>
						<Regions>
							<RegionLink active={scope === 'missing'} onClick={() => setScope('missing')}>{t('general.missingCards')} ({missing})</RegionLink>
							<RegionLink active={scope === 'all'} onClick={() => setScope('all')}>{t('general.all')} ({total})</RegionLink>
						</Regions>

						<Select
							clearable
							data={getCollectionsOptions(collections, t, null, false).reverse()}
							value={wantsList}
							onChange={setWantsList}
							placeholder={t('general.newWantsList')}
						/>
						<ToolbarButton primary onClick={addToWantsList} disabled={addToWantsListLoading}>{t('general.addToWantsList')}</ToolbarButton>
					</AddToWantsList>
				</>
			)}

			{type === 'collection' && (
				<DeckBuyLinks deckCards={missingCards} />
			)}

			<StyledDeckMissingCards>
				{type === 'collection' && scope === 'missing' ? (
					<PrintList>
						{(expanded ? missingCards : missingCards.slice(0, 3)).map((deckCard, index) => (
							<Link to={`/card/${deckCard.card.slug}`} key={`${deckCard.card.slug}${index}`}>
								<Quantity>
									{deckCard.missing}x
								</Quantity>
								<CardName
									disableHover
									name={getCardName(deckCard, cardNameLanguage)}
									image={getCardImage({
										...deckCard,
										artworkId: undefined
									}, cardNameLanguage)}
								/>
								{deckCard.price ? <CardPriceAmount amount={deckCard.price} currency={currency} /> : null}
							</Link>
						))}
					</PrintList>
				) : (
					<>
						{['main', 'extra', 'side'].map((place) => {
							const placeCards = groupDeckCards(deckCards, place)

							return placeCards.length > 0 ? (
								<Fragment key={place}>
									<PlaceHeading>{t(`general.place_${place}`)}</PlaceHeading>
									<PrintList>
										{placeCards.map(deckCard => (
											<Link to={`/card/${deckCard.card.slug}`} key={`${deckCard.card.slug}${deckCard.artworkId}`}>
												<Quantity>
													{deckCard.ids.length}x
												</Quantity>
												<CardName
													disableHover
													name={getCardName(deckCard, cardNameLanguage)}
													image={getCardImage({
														...deckCard,
														artworkId: undefined
													}, cardNameLanguage)}
													artworkNumber={getArtworkNumber(deckCard)}
												/>
												{deckCard.price ? <CardPriceAmount amount={deckCard.price} currency={currency} /> : null}
											</Link>
										))}
									</PrintList>
								</Fragment>
							) : null
						})}
					</>
				)}

				{!flyout && missingCards.length > 3 && (
					<SkipButton onClick={() => setExpanded(!expanded)}>
						<span>{expanded ? t('general.showLess') : t('general.showMore')}</span>
						<Icon name={expanded ? 'chevron-up' : 'chevron-down'} />
					</SkipButton>
				)}
			</StyledDeckMissingCards>
		</StyledDeckCollectionHelper>
	)
}

DeckCollectionHelper.propTypes = {
	cardNameLanguage: PropTypes.string,
	collections: PropTypes.array,
	deckCards: PropTypes.array.isRequired,
	deckSlug: PropTypes.string.isRequired,
	flyout: PropTypes.bool,
	priceSource: PropTypes.number.isRequired,
	queueCollectionStatsUpdate: PropTypes.func.isRequired,
	setReference: PropTypes.func.isRequired,
	shouldReload: PropTypes.func.isRequired,
	showToast: PropTypes.func.isRequired,
	subscribed: PropTypes.string,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired
}

DeckCollectionHelper.defaultProps = {
	cardNameLanguage: null,
	collections: null,
	flyout: false,
	subscribed: null
}

const StyledDeckCollectionHelper = styled.div`
	background: ${props => props.complete ? props.theme.greenLight : props.theme.background};
	border-radius: 2px;
	padding: 1rem;

	display: flex;
	flex-direction: column;

	${ThickHeading} {
		margin-bottom: 1rem;

		&:not(:first-child) {
			margin-top: 1rem;
		}
	}

	${desktop`
		${PrintList} a {
			padding-left: 0.5rem;
			margin-left: -0.5rem;
			width: calc(100% + 1rem);
		}
	`}

	${mobile`
		padding: 0;
	`}
`

const Action = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-bottom: 1rem;
`

const ActionButton2 = styled.button`
	background: transparent;
	border: 0;
	border-radius: 6px;
	color: ${props => props.theme.white};
	cursor: pointer;
	opacity: 0.8;
	padding: 0.5rem 0;
	transition: 0.1s;

	align-items: center;
	display: flex;
	justify-content: center;
	flex: 1;

	svg {
		height: 16px;
		width: 16px;
		margin-right: 0.25rem;
	}

	${props => props.active && `
		background: rgba(255, 255, 255, 0.1);
		font-weight: 600;
		opacity: 1;
	`}

	${desktop`
		&:hover {
			opacity: 1;
		}
	`}
`

const ProgressItem = styled.div`
	&:not(:last-child) {
		margin-bottom: 1rem;
	}
`

const ProgressDetails = styled.div`
	align-items: center;
	display: flex;
	margin-bottom: 0.5rem;
`

const ProgressHaves = styled.div`
	font-size: 1rem;
	font-weight: 500;
	margin-right: 0.25rem;
`

const ProgressTotal = styled.div`
	color: ${props => props.theme.textVeryLight};
	font-size: 0.8rem;
`

const MissingTitle = styled.div`
	color: ${props => props.theme.textLight};
	font-size: 0.8rem;
	font-weight: 500;
	margin-bottom: 0.5rem;
	text-transform: uppercase;
	text-align: center;
`

const MissingItems = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`

const MissingItem = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	flex-direction: column;

	background: ${props => props.theme.backgroundLight};
	border-radius: 50%;
	height: 100px;
	width: 100px;
`

const MissingItemValue = styled.div`
	font-size: 1.2rem;
	font-weight: 600;
	margin-bottom: 0.25rem;
`

const MissingItemLabel = styled.div`
	color: ${props => props.theme.textLight};
	font-size: 0.7rem;
	font-weight: 500;
	text-transform: uppercase;
`

const StyledDeckMissingCards = styled.div`
	${PrintList} {
		margin-bottom: 0;
	}

	${StyledCardPriceAmount} {
		margin-left: 0.5rem;
	}

	${StyledSkipButton} {
	}

	${desktop`
		${StyledSkipButton}:hover {
		}
	`}
`

const Quantity = styled.div`
	font-size: 0.9rem;
	font-weight: 600;
	margin-right: 0.5rem;
	width: 20px;
`

const PlaceHeading = styled.div`
	color: ${props => props.theme.textLight};
	font-size: 0.8rem;
	font-weight: 500;
	margin-bottom: 0.5rem;

	${PrintList} + & {
		margin-top: 1rem;
	}
`

const AddToWantsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;

	margin-bottom: 1.5rem;

	${Regions} {
		margin: 0;
	}

	${StyledInputContainer}, .react-select__control {
		width: 100%;
	}
`

const enhance = compose(
	connect(state => ({
		cardNameLanguage: state.persist.user.settings['app.cardNameLanguage'],
		collections: state.persist.collections,
		subscribed: state.persist.user.subscribed
	}), dispatch => bindActionCreators({
		queueCollectionStatsUpdate,
		setReference,
		shouldReload,
		showToast
	}, dispatch)),
	translate('general'),
	withTheme
)

export default enhance(DeckCollectionHelper)
